import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_ninetrader.png",
      alt: "Estratégias Nine Trader",
    },
    title: "Invista com a NineTrader",

    // String ou array de strings
    text: "Fundada por profissionais experientes no mercado financeiro, nossa empresa quer transformar a forma como você ganha dinheiro, oferecendo estratégias consistentes e confiáveis, minimizando as falhas humanas e sempre comprometida com o resultado.",
    testimonial: {
      text: "Trabalhamos com números reais, enxergamos o mercado financeiro com seriedade e queremos fazer a diferença para o mercado trader.",
      author: {
        name: "Deividi Tiago Nezi - CEO da Nine Trader",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Estratégias Nine Trader",
    heading: "Tomada de decisão baseada em estatísticas",
    subtitle:
      "São mais de 4500  indicadores matemáticos desenvolvidos  pela nine que irão ajudar você a obter a tão esperada consistência.",
  },

  cta: {
    title: "Vamos juntos nessa jornada?",
    subtitle: "Ative já a extensão Nine Trader.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Nine Trader",
    col1: [
      "Criada para proporcionar uma experiência diferenciada no mercado de renda variável, a Nine Trader oferece um processo descomplicado, prático e automatizado.",
      "Disponibilizamos estratégias de negociação baseadas em estatísticas para tomadas de decisões, evitando falhas humanas durante o processo.",
    ],
    col2: [
      "Nosso time de profissionais tem longa experiência no mercado financeiro e tem certeza que operar baseado em estatística é o caminho certo para o investidor que leva a sério o mercado financeiro.",
    ],
  },

  stats: {
    title: "Conheça os resultados da Nine Trader",
    subtitle: "Um portfólio de estratégias testadas e validadas",
    data: [
      {
        value: "+65%",
        description: "dos dias negociados positivo",
      },
      {
        value: "+72%",
        description: "dos robôs positivos no mês",
      },
      {
        value: "+10%",
        description: "em média de rentabilidade mensal",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar os robôs da Nine Trader",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.favorite,
        title: "Zero fator emocional",
        description:
          "Nosso robô toma decisões baseado em estatísticas, sem nenhum tipo de interferência humana sujeita a decisões impulsivas.",
      },
      {
        icon: iconsSet.settings_outline,
        title: "Lucre no automático",
        description:
          "Você não precisa passar o dia todo estudando gráficos. conheça a performance e a consistência desse robô que veio para quebrar paradigmas.",
      },
      {
        icon: iconsSet.charts,
        title: "Consistência",
        description:
          "Deixe nosso robô se preocupar com as entradas e preocupe-se apenas em administrar seu patrimônio.",
      },
      {
        icon: iconsSet.clock,
        title: "Economia de tempo",
        description:
          "Enquanto nosso robô trabalha seu investimento, você está livre para outras atividades.",
      },
      {
        icon: iconsSet.partner,
        title: "Qualquer um pode usar",
        description:
          "Nosso processo é descomplicado, acessível para leigos e para traders profissionais.",
      },
      {
        icon: iconsSet.paper_board,
        title: "A matemática do mercado a seu favor",
        description:
          "Deixe a matemática dos nossos robôs transformar a sua vida no mercado financeiro.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Eu aprendo muito com a Nine. Sempre me atenderam muito bem, passando tranquilidade, compartilhando conhecimento e muito preocupados com o resultado.",
      author: "Bruna Maicá da Silveira",
      job: "Administradora",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "O Deividi entende muito de trade! Estou com a Nine desde o começo e já tenho resultados consistentes.",
      author: "Jonathan Delgado Reis",
      job: "Engenheiro",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Nine Trader",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
